import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'

import { COLORS } from 'styles'

import { DataInvoices } from '../types'
import { CardDashboad } from '../components'

const useStyles = makeStyles({
  title: {
    color: COLORS.FONT,
  },
  divider: {
    backgroundColor: COLORS.BASE,
  },
})

interface PropsInvoices {
  data: DataInvoices
}

const Invoices: React.FC<PropsInvoices> = ({ data }) => {
  const classes = useStyles()
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" component="h2" className={classes.title}>
          Facturas
        </Typography>
        <Divider className={classes.divider} />
      </Grid>
      <Grid item xs={4} sm={4}>
        <CardDashboad
          value={data.created}
          description="Facturas Creadas"
          value_previous={data.created_previous}
          isPercent={false}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CardDashboad
          value={data.amount}
          description="Monto Total (UYU)"
          value_previous={data.amount_previous}
          isPercent={false}
          isCurrency
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CardDashboad
          value={data.average_amount}
          description="Promedio por Factura (UYU)"
          value_previous={data.average_amount_previous}
          isPercent={false}
          isCurrency
        />
      </Grid>
    </>
  )
}

export { Invoices }
